import type {BulkUpdateEntityType} from 'types';
import type {LinkedLiterary} from 'schemaDefinition/types';
import type {Schemas} from 'api/dto.generated';

export type BulkUpdateCreate = {
  type: BulkUpdateEntityType;
  bulkUpdateField: BulkUpdateFieldName;
  bulkUpdateAction: BulkUpdateAction;
  /** Used by remove and replace */
  currentValues?: string[] | LinkedLiterary[];
  /** Used by add and replace */
  newValues?: string[] | LinkedLiterary[];
  addToFirstPosition?: boolean;
};

export type BulkUpdateCreateResponse = {
  id: string;
};

export type BulkUpdateAction = 'ADD' | 'REMOVE' | 'REPLACE';

export type BulkUpdateFieldName =
  | Exclude<Schemas.BulkUpdateWorkField['field'], 'seriesRelations'>
  | 'links';

export type BulkUpdateStatus =
  | 'NEW'
  | Schemas.BulkUpdateStatusResponse['status'];

export type BulkUpdateItemStatus =
  | 'NEW'
  | 'UNPROCESSED'
  | 'SUCCEEDED'
  | 'FAILED';

export type BulkUpdate = BulkUpdateCreate &
  Pick<Schemas.BulkUpdateStatusResponse, 'items'> & {
    id: string;
    status: BulkUpdateStatus;
    created: string; // Formatted as string in mapping
    completed?: string; // Formatted as string in mapping
  };

export type BulkUpdateList = {
  pages: number;
  elements: number;
  items: BulkUpdateSummary[];
};

export type BulkUpdateSummary = BulkUpdateCreate &
  Schemas.BulkUpdateSummaryItems &
  Pick<
    Schemas.BulkUpdateSummary,
    'id' | 'status' | 'items' | 'created' | 'completed'
  >;

export type BulkUpdateFailedItem = Schemas.BulkUpdateFailedItem;
export type BulkUpdateErrorKey =
  | 'WORK_ENTITY_NOT_FOUND'
  | 'VALUE_NOT_PRESENT'
  | 'VALUE_ALREADY_PRESENT'
  | 'INVALID_THEMA'
  | 'SYSTEM_ERROR';
export const BulkUpdateErrorKeys: BulkUpdateErrorKey[] = [
  'WORK_ENTITY_NOT_FOUND',
  'VALUE_NOT_PRESENT',
  'VALUE_ALREADY_PRESENT',
  'INVALID_THEMA',
  'SYSTEM_ERROR',
];
